import TopNavReportsV3 from "./TopNavReportsV3";

const DashboardHeaderReportsV3 = ({
  tabs = [],
  isFullWidth,
  parentPath,
  navigationState,
  setNavigationState,
  topNavBorderless,
  sticky,
  onToggleExpand,
  onDuplicate,
  viewportFill,
  onImport,
  onCreate,
  onCreateMultiTable,
}) => {
  return (
    <TopNavReportsV3
      tabs={tabs}
      parentPath={parentPath}
      navigationState={navigationState}
      setNavigationState={setNavigationState}
      isFullWidth={isFullWidth}
      borderless={topNavBorderless}
      sticky={sticky}
      onToggleExpand={onToggleExpand}
      onDuplicate={onDuplicate}
      viewportFill={viewportFill}
      onImport={onImport}
      onCreate={onCreate}
      onCreateMultiTable={onCreateMultiTable}
    />
  );
};

export default DashboardHeaderReportsV3;
